import * as React from "react";

export function useMediaQuery(query: string) {
  // Initialise synchronously so the first render already reflects the real
  // viewport — avoids a layout flash where a desktop briefly renders the
  // mobile branch (and vice-versa) before the effect runs.
  const [value, setValue] = React.useState(() =>
    typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(query).matches
      : false,
  );

  React.useEffect(() => {
    function onChange(event: MediaQueryListEvent) {
      setValue(event.matches);
    }

    const result = matchMedia(query);
    result.addEventListener("change", onChange);
    setValue(result.matches);

    return () => result.removeEventListener("change", onChange);
  }, [query]);

  return value;
}
